import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { 
  Card, 
  Form, 
  Input, 
  Button, 
  Typography, 
  Divider
} from 'antd';
import { 
  UserOutlined, 
  LockOutlined, 
  HeartOutlined 
} from '@ant-design/icons';

const { Title, Text } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const result = await login(values.email, values.password);
      if (result.success) {
        toast.success('Добро пожаловать!');
        navigate('/');
      } else {
        toast.error(result.error);
      }
    } catch (error) {
      toast.error('Произошла ошибка при входе');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <Card 
        style={{ 
          width: '100%', 
          maxWidth: '400px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
          borderRadius: '12px'
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <HeartOutlined 
            style={{ 
              fontSize: '48px', 
              color: '#2196F3',
              marginBottom: '16px'
            }} 
          />
          <Title level={2} style={{ margin: 0, color: '#333' }}>
            Open Hearts
          </Title>
          <Text type="secondary">
            Панель администратора
          </Text>
        </div>

        <Form
          name="login"
          onFinish={onFinish}
          layout="vertical"
          size="large"
        >
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: 'Введите email' },
              { type: 'email', message: 'Введите корректный email' }
            ]}
          >
            <Input 
              prefix={<UserOutlined />} 
              placeholder="admin@openhearts.tj"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="Пароль"
            rules={[{ required: true, message: 'Введите пароль' }]}
          >
            <Input.Password 
              prefix={<LockOutlined />} 
              placeholder="Введите пароль"
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={loading}
              block
              style={{ height: '48px' }}
            >
              Войти
            </Button>
          </Form.Item>
        </Form>

        <Divider />
        
        <div style={{ textAlign: 'center' }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            Тестовые данные для входа:
          </Text>
          <br />
          <Text type="secondary" style={{ fontSize: '12px' }}>
            Email: admin@openhearts.tj
          </Text>
          <br />
          <Text type="secondary" style={{ fontSize: '12px' }}>
            Пароль: admin123
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default Login;
